
// src/web/components/group-export-panel.jsx

import React from 'react'
import connect from '../../connects/group-export-panel'
import {
  Card,
  CardText,
  CardTitle,
  CardActions
} from 'react-toolbox/lib/card'
import Checkbox from 'react-toolbox/lib/checkbox'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import DropDown from 'react-toolbox/lib/dropdown'
import {
   linkUI 
} from '../../helpers/form-validator'
import moment from 'moment'
import theme from './themes/flat-card.css'
import DatePicker from './date-picker.jsx'
import { GoogleLogin } from './google-signin-provider.jsx'
import reportStatusTheme from './themes/report-status.css'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import Loading from './loading.jsx'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import FontIcon from 'react-toolbox/lib/font_icon'
import {
  Input,
} from 'react-toolbox/lib/input'
import {
  RadioButton,
  RadioGroup
 } from 'react-toolbox/lib/radio'

class GroupExportPanel extends React.Component {
  state = {
    exportAll: true,
    fields: [],
    showMenu: false,
    checkDates: true,
    checkRefreshToken: true,
    sendingMethodValue: 'mail',
    checkFolder: true,
    checkSaveFolder: true,
  }

  toggleExportAll = ()=> this.setState({ exportAll:  !this.state.exportAll })
  toggleField = (field)=> {
    if (this.state.fields.includes(field))
      this.setState({ fields: _.filter(this.state.fields, (_field)=> _field != field) })
    else
      this.setState({ fields: this.state.fields.concat(field) })
  }
  
  unLinkGoogleDrive = ()=> {
    this.props.cancelGoogleDrive()
    this.props.ui.gapiReady && GoogleLogin.signOut()
    this.props.updateUI({ gapiReady: false, folder_id: 'undefined' })
  }

  onGoogleSignSuccess = ()=> {
    this.props.fetchUserInfo()
    this.props.fetchFolders()
    this.props.updateUI({ gapiReady: true })
  }

  onGoogleCodeSuccess = ()=> {
    this.props.fetchRefreshToken()
  }

  onSelectFolder = (folder_id) => {
    this.props.updateUI({ folder_id: folder_id })
    this.setState({ checkFolder: true })
  }

  toggleIsScheduled = ()=> {
    this.props.updateUI({ isScheduled: !this.props.ui.isScheduled })
  }

  onSelectScheduledFolder = (save_folder_id) => {
    this.props.updateUI({ save_folder_id: save_folder_id })
    this.setState({ checkSaveFolder: true })
  }

  onSelectInterval = (interval) => {
    this.props.updateUI({ interval: interval })
  }

  onUpdateScheduledSettings = () => {
    if (this.props.ui.refreshToken) {
      this.setState({ checkRefreshToken: true })
      
      // check GoogleDrive folder validation
      if (this.props.ui.save_folder_id == 'undefined') {
        this.setState({ checkSaveFolder: false })
      } else {
        this.setState({ checkSaveFolder: true })
        this.props.updateScheduledSettings(this.props)
      }
    } else {
      this.setState({ checkRefreshToken: false })
    }
  }

  onDownloadFile = (fields) => {
    // Parse the start and end dates using moment
    const startDate = moment(this.props.ui.startDate)
    const endDate = moment(this.props.ui.endDate)
    // Calculate the difference in days
    const dateDifference = endDate.diff(startDate, 'days');
    // Check if the difference is greater than 366 days
    if (dateDifference > 366) {
      this.setState({ checkDates: false })
    } else {
      this.setState({ checkDates: true })
      if (this.state.sendingMethodValue == 'mail') {
        window.open(this.props.groupExportUrl(this.props.ui.startDate, this.props.ui.endDate, fields))
      } else {
        // check GoogleDrive folder validation
        if (this.props.ui.folder_id == 'undefined') {
          this.setState({ checkFolder: false })
        } else {
          this.setState({ checkFolder: true })
          this.props.downloadFile(this.props, fields)
        }
      }
    }
  }

  sendingMethodChange = (value)=> {
    this.setState({ sendingMethodValue:  value })
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isFoldersFetchFailed && this.props.isFoldersFetchFailed) {
      GoogleLogin.signOut()
      this.props.updateUI({ gapiReady: false })
    }

    if (!prevProps.refresh_token && this.props.refresh_token) {
      this.props.updateUI({ refreshToken: this.props.refresh_token })
      this.setState({ checkRefreshToken: true })
    }

    if (!prevProps.scheduled_settings && this.props.scheduled_settings) {
      const settings = this.props.scheduled_settings
      if (settings.generate_next_at) this.props.updateUI({ scheduledDate: moment(settings.generate_next_at) })
      if (settings.is_active) this.props.updateUI({ isScheduled: settings.is_active })
      if (settings.folder_id) this.props.updateUI({ save_folder_id: settings.folder_id })
      if (settings.interval) this.props.updateUI({ interval: settings.interval })
      if (settings.refresh_token) this.props.updateUI({ refreshToken: settings.refresh_token })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.field_list != nextProps.field_list)
      this.setState({ fields: nextProps.field_list })
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      groupExportUrl,
      field_list,
      folders,
      userinfo,
      isFoldersFetching,
      isFoldersFetchFailed,
      fetchFolders,
      fetchUserInfo,
      cancelGoogleDrive,
      isUserInfoFetching,
      isUserInfoFetchFailed,
      isUploadFetching,
      isUploadFetchFailed,
      downloadFile,
      fetchRefreshToken,
      isRefreshTokenFetching,
      isRefreshTokenFailed,
      refresh_token,
      fetchScheduledSettings,
      isScheduledSettingsFetching,
      isScheduledSettingsFailed,
      updateScheduledSettings,
      isUpdateScheduledSettingsFetching,
      isUpdateScheduledSettingsFailed,
      scheduled_settings,
      currentUser,
    } = this.props

    let arrowClassName = ui.isScheduled ? 'keyboard_arrow_down' : 'keyboard_arrow_right'

    let dropDownSource = [
      { value: 'undefined', label: t('label:フォルダを選択して下さい') }
    ]

    let scheduledDropDownSource = [
      { value: 'undefined', label: t('label:フォルダを選択して下さい') }
    ]

    if (folders && folders.length > 0) {
      const folderOptions = folders.map(folder => ({
        value: folder.id,
        label: folder.name
      }))
      dropDownSource = dropDownSource.concat(folderOptions)
      scheduledDropDownSource = scheduledDropDownSource.concat(folderOptions)
    }

    let intervalDropDownSource = [
      { value: 'week', label: t('label:週') },
      { value: 'month', label: t('label:月次') }
    ]

    return (
      <Card theme={theme}>
        <CardText>
          <strong>{t('label:開始日')}</strong>
          <DatePicker label={t('label:開始日')}
              value={ui.startDate.toDate()}
              maxDate={ui.endDate.toDate()}
              onChange={(date)=> updateUI({ startDate: moment(date) })} />
        </CardText>

        <CardText>
          <strong>{t('label:終了日')}</strong>
          <DatePicker label={t('label:終了日')}
              value={ui.endDate.toDate()}
              minDate={ui.startDate.toDate()}
              onChange={(date)=> updateUI({ endDate: moment(date) })} />
        </CardText>
        {!this.state.checkDates &&
        <CardText style={{ color: 'red' }}>
          <FontIcon value='error' style={{ verticalAlign: 'bottom', fontSize: 18 }}/>
          <span style={{ marginLeft: 5 }}>{t('label:日報のエクスポートは最大1年分')}</span>
        </CardText>
        }
        {field_list  && field_list.length > 0 &&
        <CardActions>
          <div>
          <Checkbox checked={this.state.exportAll}
            label={t('label:すべて抽出')}
            onChange={this.toggleExportAll} />
          <ul>
          {!this.state.exportAll && _.map(field_list, (field, i)=> 
            <li key={i}>
              <Checkbox checked={this.state.fields.includes(field)}
                label={field} onChange={()=> this.toggleField(field)} />
            </li>
          )}
          </ul>
          </div>
        </CardActions>
        }
        {(isFoldersFetching || isUploadFetching || isUserInfoFetching) &&
        <Loading />
        }
        <CardText className={reportStatusTheme.sendingMethod}>
          <strong>{t('label:送信方法')}</strong>
          <RadioGroup
            className={reportStatusTheme.radioGroup}
            value={this.state.sendingMethodValue}
            onChange={this.sendingMethodChange}
          >
            <RadioButton label={t('label:メール')} value='mail'>
              <span className={reportStatusTheme.mailContent}>{currentUser.email} へ送信します</span>
            </RadioButton>
            <RadioButton label='Googleドライブ' value='drive' />
          </RadioGroup>
        </CardText>

        {this.state.sendingMethodValue == 'drive' &&
        <div>
          <CardText className={reportStatusTheme.googleSignInBtn}>
            {!ui.gapiReady &&
            <GoogleLogin label={t('label:Googleドライブに接続する')} onSuccess={this.onGoogleSignSuccess} type={'google_drive'} />
            }
            {!isUserInfoFetchFailed && ui.gapiReady && userinfo &&
            <List>
              <span className={reportStatusTheme.normalTitle}>{t('label:アカウント')}</span>
              <ListItem
                className={reportStatusTheme.userInfo}
                rightActions={[
                  <IconMenu key="menu" icon="more_vert" onClick={()=> this.setState({ showMenu: true })}>
                    <MenuItem
                      icon="delete_forever"
                      onClick={this.unLinkGoogleDrive}
                      caption={t('label:Googleドライブを解除')}
                    />
                  </IconMenu>
                ]}
              >
                <span>{userinfo.displayName}</span>
                <span>({userinfo.emailAddress})</span>
              </ListItem>
            </List>
            }
            {ui.gapiReady &&
            <List>
              <span className={reportStatusTheme.normalTitle}>{t('label:フォルダの選択')}</span>
              {folders && folders.length == 0 &&
                <ListItem caption={t('label:フォルダがありません')} selectable={false} />
              }
              <DropDown auto
                source={dropDownSource}
                value={ui.folder_id}
                onChange={this.onSelectFolder}
              />
              {!this.state.checkFolder &&
              <CardText style={{ color: 'red', paddingLeft: 0, paddingTop: 0 }}>
                <FontIcon value='error' style={{ verticalAlign: 'bottom', fontSize: 18 }}/>
                <span style={{ marginLeft: 5 }}>{t('label:フォルダを選択して下さい1')}</span>
              </CardText>
              }
            </List>
            }
          </CardText>
        </div>
        }
        <CardText>
          <Button raised primary
            disabled={this.state.sendingMethodValue == 'drive' && !ui.gapiReady}
            onClick={()=> this.onDownloadFile(this.state.exportAll ? undefined : _.filter(field_list, (item)=> this.state.fields.includes(item)))}
            style={{width: '100%'}}
            label={t('label:エクスポート')}
          />
        </CardText>

        <CardText style={{ marginTop: 10 }}>
          <Checkbox
            label={t('label:定期的にGoogleドライブへ自動保存する')}
            checked={ui.isScheduled}
            onChange={this.toggleIsScheduled}
          >
            <FontIcon style={{ display: 'inline-block', marginTop: -2 }} value={arrowClassName}/>
          </Checkbox>
        </CardText>

        {ui.isScheduled &&
        <div>
          {(isRefreshTokenFetching || isScheduledSettingsFetching || isUpdateScheduledSettingsFetching) &&
          <Loading />
          }
          { !ui.refreshToken &&
          <CardText>
            <GoogleLogin label={t('label:Googleドライブに連携する')} onCodeSuccess={this.onGoogleCodeSuccess} type={'refresh_token'} />
          </CardText>
          }
          { ui.refreshToken &&
          <CardText style={{ color: 'green' }}>
            <FontIcon value='check_circle' style={{ verticalAlign: 'bottom', fontSize: 18 }}/>
            <span style={{ marginLeft: 5, color: 'black' }}>{t('label:連携済み')}</span>
          </CardText>
          }
          {!this.state.checkRefreshToken &&
          <CardText style={{ color: 'red' }}>
            <FontIcon value='error' style={{ verticalAlign: 'bottom', fontSize: 18 }}/>
            <span style={{ marginLeft: 5 }}>{t('label:Googleドライブが設定されていません')}</span>
          </CardText>
          }
          <CardText>
            <strong>{t('label:フォルダの選択')}</strong>
            {folders && folders.length == 0 &&
            <List>
              <ListItem caption={t('label:フォルダがありません')} selectable={false} />
            </List>
            }
            {!ui.gapiReady &&
            <List>
              <ListItem  className={reportStatusTheme.folderItem} caption={t('label:Googleドライブが設定されていません')} selectable={false} />
            </List>
            }
            {ui.gapiReady &&
            <DropDown auto
              source={scheduledDropDownSource}
              value={ui.save_folder_id}
              onChange={this.onSelectScheduledFolder}
            />
            }
            {!this.state.checkSaveFolder &&
            <CardText style={{ color: 'red', paddingLeft: 0, paddingTop: 0 }}>
              <FontIcon value='error' style={{ verticalAlign: 'bottom', fontSize: 18 }}/>
              <span style={{ marginLeft: 5 }}>{t('label:フォルダを選択して下さい1')}</span>
            </CardText>
            }
          </CardText>
          <CardText>
            <span style={{ fontSize: 16, fontWeight: 'bold' }}>{t('label:期間設定')}</span>
          </CardText>
          <CardText>
            <strong>{t('label:日付')}</strong>
            <DatePicker label={t('label:日付')}
              value={ui.scheduledDate.toDate()}
              minDate={moment().toDate()}
              onChange={(date)=> updateUI({ scheduledDate: moment(date) })} />
          </CardText>
          <CardText>
            <strong>{t('label:間隔')}</strong>
            <DropDown auto
              source={intervalDropDownSource}
              value={ui.interval}
              onChange={this.onSelectInterval}
            />
            <Button raised primary
              onClick={this.onUpdateScheduledSettings}
              style={{width: '100%'}}
              label={t('label:更新する')}
            />
          </CardText>
        </div>
        }
      </Card>
    )
  }
}

export const RawGroupExportPanel = GroupExportPanel
export default connect(GroupExportPanel)



// WEBPACK FOOTER //
// ./src/web/components/group-export-panel.jsx